import React from "react";
import { Link } from "react-router-dom";
import LegalPage, { InfoCard } from "@/components/LegalPage";
import { Rocket, Heart, Briefcase, MapPin, MessageCircle, Zap } from "lucide-react";

export default function Careers() {
  const sections = [
    {
      id: "why", title: "Why MystiCast", icon: Rocket,
      body: (
        <p>
          We&apos;re a small team of engineers, designers, and community builders on a real bet:
          that the next streaming platform will be one where <strong>viewers are participants</strong>, not just an audience.
          If that idea makes you lean forward, we should talk.
        </p>
      ),
    },
    {
      id: "values", title: "What We Value", icon: Heart, highlight: "pink",
      body: (
        <>
          <InfoCard icon={Zap} title="⚡ Ship > theater" tone="volt">
            <p>We prefer engineers who&apos;d rather deploy on Friday than write a doc about deploying on Friday.</p>
          </InfoCard>
          <InfoCard icon={Heart} title="🎨 Craft > churn" tone="pink">
            <p>Every screen matters. Every micro-interaction. Every empty state.</p>
          </InfoCard>
          <InfoCard icon={Heart} title="🤝 Creator empathy" tone="cyan">
            <p>Half of us have streamed something. All of us have watched creators get squeezed by fees. We want to be the ones who didn&apos;t.</p>
          </InfoCard>
          <InfoCard icon={Zap} title="🎯 Low ego, high standards" tone="orange">
            <p>Disagree loud, decide fast, move on.</p>
          </InfoCard>
        </>
      ),
    },
    {
      id: "roles", title: "Open Roles", icon: Briefcase,
      body: (
        <>
          <p>We&apos;re not actively hiring for named roles right now, but we&apos;re always interested in meeting exceptional people in these areas:</p>
          <ul>
            <li><strong>Full-stack engineers</strong> (React + Python / FastAPI)</li>
            <li><strong>WebRTC / real-time infra engineers</strong></li>
            <li><strong>Product designers</strong> who care about motion and interaction depth</li>
            <li><strong>Trust & safety operators</strong></li>
            <li><strong>Creator success / community managers</strong></li>
          </ul>
        </>
      ),
    },
    {
      id: "how", title: "How to Reach Us", icon: MessageCircle,
      body: (
        <p>
          Send a note through <Link to="/contact">the contact page</Link> mentioning &quot;Careers&quot; in the subject.
          Include: a short pitch about who you are, links to your best work (repo, portfolio, streams), and what you&apos;d want to build here.
          We read everything, though we can&apos;t respond to everyone.
        </p>
      ),
    },
    {
      id: "location", title: "Location & Comp", icon: MapPin,
      body: (
        <p>
          We&apos;re remote-first with core hours overlapping US Pacific afternoons. Compensation is market for the role plus meaningful equity.
        </p>
      ),
    },
  ];

  return (
    <LegalPage
      icon={Briefcase}
      label="TEAM"
      title="Careers"
      intro="We're building the next streaming platform. Come build it with us."
      sections={sections}
      contact={{
        title: "Want to work with us?",
        body: "Mention \"Careers\" in your message. Include links to your best work — code, designs, streams, whatever tells us who you are.",
        cta: { label: "Say Hi", to: "/contact" },
      }}
    />
  );
}
